import { skipToken, useQuery } from '@tanstack/react-query';
import { SyncFailuresApi } from '@/lib/api/work-integrations/syncFailures';
import { workIntegrationsQueryKeys } from '@/lib/query-keys/work-integrations';

const SYNC_FAILURES_STALE_TIME_MS = 60_000;

export const useGetItemSyncFailedItems = ({
  itemIdOrSourceItemKey,
  page,
  pageSize,
  enabled = true,
}: {
  itemIdOrSourceItemKey?: string;
  page?: number;
  pageSize?: number;
  enabled?: boolean;
}) => {
  return useQuery({
    queryKey: workIntegrationsQueryKeys.syncFailedItemsForItem({
      itemIdOrSourceItemKey,
      page,
      pageSize,
    }),
    queryFn: itemIdOrSourceItemKey
      ? () => SyncFailuresApi.getSyncFailedItemsByItem({ itemIdOrSourceItemKey, page, pageSize })
      : skipToken,
    enabled,
    staleTime: SYNC_FAILURES_STALE_TIME_MS,
  });
};
